import { NgModule } from '@angular/core';
import { ProjectService } from '../services/project.service';
import { ProjectAddModule } from './project-add/project-add.module';
import { ProjectListModule } from './project-list/projects.module';
import { ProjectModifyModule } from './project-modify/project-modify.module';
import { ProjectMarketsServiceProvider } from '../services/project-markets.service';
import { ProductServiceProvider } from '../services/product-service';
import { DataViewAllClientsService } from '../services/data-view-all_clients.service';

@NgModule({
  imports: [ProjectListModule, ProjectAddModule, ProjectModifyModule],
  exports: [ProjectListModule, ProjectAddModule, ProjectModifyModule],
  providers: [ProjectService, ProductServiceProvider, ProjectMarketsServiceProvider, DataViewAllClientsService],
})
export class ProjectsModule {}



// WEBPACK FOOTER //
// ./src/modules/projects/pages/projects.module.ts